import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { from, map } from 'rxjs';
import { SupportedDevicesService } from '../../../services/supported-devices/supported-devices.service';

export const supportedDevicesGuard: CanActivateFn = () => {
  const platform = inject(PLATFORM_ID);

  const supportedDevicesService = inject(SupportedDevicesService);

  if (isPlatformBrowser(platform)) {
    return true;
  }

  return from(supportedDevicesService.initInServer()).pipe(map(() => true));
};
